<div class="tw-relative tw-flex tw-h-40 tw-w-full tw-overflow-hidden tw-rounded-2 tw-border tw-border-solid tw-border-gray-200 tw-bg-white">
  <div class="tw-h-40 tw-w-32 tw-shrink-0 tw-bg-gray-100" (click)="onViewDetail()">
    @if (imageUrl) {
      <img class="tw-h-full tw-w-full tw-object-cover" [src]="imageUrl" alt="" />
    }
  </div>
  <div class="tw-flex tw-flex-1 tw-flex-col tw-justify-center tw-gap-3 tw-px-4">
    <div class="tw-flex tw-flex-col">
      <p class="tw-text-200 tw-font-lexend tw-font-medium tw-text-gray-800">{{ item().product?.title || item().title }}</p>
      <p class="tw-text-100 tw-font-body tw-font-medium tw-text-gray-400">{{ item().quantityData }}</p>
      <div class="tw-flex tw-items-center tw-gap-1">
        <del class="tw-text-200 tw-font-lexend tw-font-medium tw-text-gray-500">₹{{ item().mrp }}</del>
        <span class="tw-text-300 tw-font-lexend tw-font-bold tw-text-orange-500">₹{{ item().price }}</span>
      </div>
    </div>
    <div class="tw-flex tw-items-center tw-gap-3">
      <div class="tw-flex tw-h-6 tw-items-center tw-overflow-hidden tw-rounded-1.5 tw-border tw-border-solid tw-border-teal-600 tw-text-teal-600">
        <div class="tw-flex tw-h-full tw-w-8 tw-items-center tw-justify-center tw-text-300 tw-font-lexend tw-font-semibold"
          (click)="onDecrement()">-</div>
        <div class="tw-text-300 tw-font-lexend tw-font-semibold">{{ displayQuantity }}</div>
        <div class="tw-flex tw-h-full tw-w-8 tw-items-center tw-justify-center tw-text-300 tw-font-lexend tw-font-semibold"
          (click)="onIncrement()">+</div>
      </div>
      <p class="tw-text-100 tw-font-body tw-font-medium tw-text-gray-400" (click)="onRemove()" i18n="@@remove"> Remove </p>
    </div>
  </div>
  @if (item().isDoctorAdded) {
    <div class="tw-absolute tw-right-0 tw-top-1 tw-flex tw-h-5 tw-items-center tw-gap-1 tw-overflow-hidden tw-rounded-l-1 tw-bg-orange-100 tw-px-1.5 tw-py-1">
      <cs-icon class="tw-h-2.5 tw-w-2.5 tw-text-orange-400" [iconName]="'dr_suggested'"></cs-icon>
      <span class="tw-text-50 tw-font-lexend tw-font-medium tw-text-orange-400" i18n="@@drSuggested"> Dr. Suggested </span>
    </div>
  }
</div>
